import type { PushSubscriptionInput } from '../profile/profileApi'
import { publicPath } from '../../shared/publicPath'

const PERMISSION_GUIDANCE = '通知权限被系统拒绝。请先将应用添加到主屏幕，再到系统“设置 > 通知 > 昭游智伴侣”中允许通知'

export const pushNotifications = {
  supported: () => typeof Notification !== 'undefined' && 'serviceWorker' in navigator && 'PushManager' in window,
  permission: () => typeof Notification === 'undefined' ? 'unsupported' : Notification.permission,
  current: async () => {
    try { return await (await navigator.serviceWorker.getRegistration())?.pushManager.getSubscription() ?? null }
    catch (reason) { if (isPermissionDenied(reason)) return null; throw reason }
  },
  subscribe: async (publicKey: string) => {
    if (!pushNotifications.supported()) throw new Error('当前浏览器不支持系统通知')
    const permission = await Notification.requestPermission()
    if (permission !== 'granted') throw new Error(PERMISSION_GUIDANCE)
    const registration = await navigator.serviceWorker.getRegistration() ?? await navigator.serviceWorker.register(publicPath('sw.js'))
    try {
      return await registration.pushManager.getSubscription() ?? await registration.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: decodeBase64Url(publicKey) })
    } catch (reason) {
      if (isPermissionDenied(reason)) throw new Error(PERMISSION_GUIDANCE)
      throw reason
    }
  },
  input: (subscription: PushSubscription): PushSubscriptionInput => {
    const value = subscription.toJSON()
    if (!value.endpoint || !value.keys?.p256dh || !value.keys.auth) throw new Error('浏览器返回的通知订阅无效')
    return { endpoint: value.endpoint, expirationTime: value.expirationTime ?? null, keys: { p256dh: value.keys.p256dh, auth: value.keys.auth } }
  }
}

function isPermissionDenied(reason: unknown) {
  const text = typeof reason === 'string' ? reason : reason && typeof reason === 'object' ? `${'name' in reason ? reason.name : ''} ${'message' in reason ? reason.message : ''}` : ''
  return /permission denied|notallowederror|securityerror/i.test(text)
}

function decodeBase64Url(value: string) {
  const padded = `${value}${'='.repeat((4 - value.length % 4) % 4)}`.replace(/-/g, '+').replace(/_/g, '/')
  return Uint8Array.from(atob(padded), (character) => character.charCodeAt(0))
}
